export const cargoUnloadingTblDefs = [
    { header: 'LR No.', dataKey: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'left' } },
    { header: 'From City', dataKey: 'FromCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'left' } },
    { header: 'To City', dataKey: 'ToCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'left' } },
    { header: 'Sender Name', dataKey: 'Sender', xlCol: { dataType: 'string', textAlign: 'right', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'left' } },
    { header: 'Receiver Name', dataKey: 'Receiver', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'left' } },
    { header: 'NOP', dataKey: 'NOP', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'right' } },
    { header: 'Charged Weight', dataKey: 'CHARGEDWEIGHT', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'right' } },
    { header: 'Freight Charge', dataKey: 'FREIGHT', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'right' } },
    { header: 'Total Amount', dataKey: 'NETAMOUNT', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'right' } },
    { header: 'LR Status', dataKey: 'status', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '11.102%', textAlign: 'left' } },
  ]

  export const headerTblDefs = [
    { header: 'Dispatch Date', dataKey: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null } },
    { header: 'Branch Name', dataKey: 'branchName', xlCol: { dataType: 'string', dataFormatter: null } },
    { header: 'Vehicle No.', dataKey: 'vehicleNo', xlCol: { dataType: 'string', dataFormatter: null } },
  ]

  export const cargoUnloadingTblStyles = {
    0: {cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    1: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    2: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    3: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    4: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    5: { cellWidth: 117.99, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    6: { cellWidth: 117.99, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    7: { cellWidth: 117.99, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    8: { cellWidth: 117.99, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    9: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
  }
  export const cargoUnloadingStylesWithFormattedLR = {
    0: {cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    1: {cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    2: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    3: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    4: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    5: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    6: { cellWidth: 107.26, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    7: { cellWidth: 107.26, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    8: { cellWidth: 107.26, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    9: { cellWidth: 107.26, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    10: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
  }
  export const cellStyles = {
    minCellHeightheight: '50px',
    padding: '7px 12px',
    alignItems: 'flexStart',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    whiteSpace: "nowrap",
    verticalAlign: 'top',
    textAlign: 'left',
  }
  export const totalRowStyles = {
    height: '36px',
    padding: '7px 12px',
    backgroundColor: "#eeeeee",
    textAlign: "right",
    color: '#444444',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  }
  export const headCellStyles = {
    borderStyle: 'solid',
    borderWidth: '0px 0px',
    backgroundColor: "#BFE1FF",
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 600,
    minCellHeight: '44px',
    padding: '7px 12px 7px 12px',
    whiteSpace: "nowrap",
    verticalAlign: 'top',
    color:'#444444'
  }